(function () {
  if (!Shopify || !Shopify.designMode) return;

  document.addEventListener("shopify:block:select", function (event) {
    const blockId = event.detail.blockId;
    const selectedSlide = document.querySelector(
      `[data-block-id="${blockId}"]`
    );

    if (!selectedSlide) return;

    // Find the parent slideshow component
    const slideshow = selectedSlide.closest("slideshow-component");

    if (!slideshow) return;

    // Function to navigate to the selected slide
    const navigateToSlide = () => {
      if (slideshow.swiper) {
        // Find the real index of the slide
        const allSlides = slideshow.querySelectorAll(
          ".swiper-slide:not(.swiper-slide-duplicate)"
        );
        let realIndex = 0;

        allSlides.forEach((slide, index) => {
          if (slide.dataset.blockId === blockId) {
            realIndex = index;
          }
        });

        // Pause autoplay if active
        if (slideshow.swiper.autoplay && slideshow.swiper.autoplay.running) {
          slideshow.swiper.autoplay.stop();
        }

        // Navigate to the selected slide
        if (slideshow.swiper.params.loop) {
          slideshow.swiper.slideToLoop(realIndex, 300);
        } else {
          slideshow.swiper.slideTo(realIndex, 300);
        }
      } else {
        // Swiper not initialized yet, retry
        setTimeout(navigateToSlide, 50);
      }
    };

    navigateToSlide();
  });

  // Optional: Handle block deselect to resume autoplay
  document.addEventListener("shopify:block:deselect", function (event) {
    const blockId = event.detail.blockId;
    const deselectedSlide = document.querySelector(
      `[data-block-id="${blockId}"]`
    );

    if (!deselectedSlide) return;

    const slideshow = deselectedSlide.closest("slideshow-component");

    if (!slideshow || !slideshow.swiper) return;

    // Resume autoplay if it was enabled
    const autoplayEnabled = slideshow.dataset.autoplay === "true";
    if (autoplayEnabled && slideshow.swiper.autoplay) {
      // Small delay before resuming
      setTimeout(() => {
        if (slideshow.swiper && slideshow.swiper.autoplay) {
          slideshow.swiper.autoplay.start();
        }
      }, 500);
    }
  });
})();
